import { formatPrice } from "components/Price/Price"
import React, { Component } from "react"
import { Redirect } from "react-router"
import { Link, withRouter } from "react-router-dom"
import { Breadcrumb, Table, Menu, Input, Label, Button, Checkbox, Form, Segment, Loader } from "semantic-ui-react"
import store from "store"
import customerStore from "stores/customerStore"
import ServerStore from "sdk/store/ServerStore"
import { observer } from "mobx-react"
import $fetch from "sdk/$fetch"
import shop from "shop/shop"
import settingStore from "stores/settingStore";

let didRun = false

@withRouter
@observer
export default class AccountSelection extends Component {

  state = {
    size          : false,
    customers     : [],
    loadingRestore: true,
    customerId    : false,
    query         : "%%"
  }

  async componentWillMount() {
    this.loadMore()
    if ( didRun ) return this.setState( { loading: false, loadingRestore: false } )
    didRun = true

    const { restoreId } = customerStore
    if ( restoreId ) {
      console.log( "Set CUSTOMER FROM RESTORE TOKEN" )
      const response = await customerStore.setCustomer( restoreId )
      console.log( "CUSTOMER SET", response )
      if ( response ) {
        this.setState( { loading: false, loadingRestore: false, customerId: restoreId } )
        return
      }
    }

    this.setState( { loading: false, loadingRestore: false } )
  }

  loadMore = () => {
    this.setState( { loading: true } )
    const { query } = this.state
    shop.fetch( `/shop/rest/data/customers/search?title=${encodeURIComponent( query )}&count=${500}&start=${0}` ) // pre-urlencoded % = %25
      .then( data => {
        const { size, result } = data
        this.handleResult( { size, customers: result, query } )
        this.setState( { loading: false } )
        console.log("CUSTOMERS", result)
      } )
      .catch( error => {
        this.setState( { error } )
        shop.toast( translate( "toast.SESSION_CLOSED" ) )
        console.error( "Error fetching customers", error )
      } )
  }

  handleResult = ( { size, customers, query } ) => {
    this.setState( { size, customers, query } )
  }

  componentDidMount() {
    customerStore.get( { count: 30 } )
  }

  handleSelect = async ( { customer } ) => {
    console.log( "customer", customer )
    $fetch.clear()
    try {
      store.set( `ihand-customer-${customer.map_id}`, customer )
      await customerStore.setCustomer( customer.map_id )
      const mode = settingStore.get( "orderMode" )
      if ( mode === "MODE_PREORDER" ) {
        shop.cart.setExtra( "preorder", true )
      } else {
        shop.cart.setExtra( "preorder", false )
      }
      shop.cart.setExtra( { orderMode: mode } )
      this.props.history.push( this.props.to || "/" )
      shop.orderlist.resetOrderlists() // NEU localStorage Reset für Merklisten
      shop.store.server.hydrate() // NEU Reload der Merklisten aus Backend
      console.log('list reset',shop.orderlist)
    } catch (err) {
      shop.toast( `${translate( "toast.CUSTOMER_SELECTION_ERROR" )} ${err}` )
    }
  }

  render() {
    const { size, customerId, customers, loadingRestore, loading } = this.state
    const searchResult = customers

    const useMore = size > customers.length

    if ( loadingRestore ) return <Segment>
      <div className="pa3"><Loader active/></div>
    </Segment>

    if ( customerId ) return <div>
      REDIRECT {shop.locationAfterLogin || "/"}
      <Redirect replace to={shop.locationAfterLogin || "/"}/>
    </div>

    return  <div className="w-100">
      <div className="db pv3 mb-2">
      <Breadcrumb>
        <Breadcrumb.Section link as={Link} to="/">Home</Breadcrumb.Section>
      </Breadcrumb>
      </div>
      <h3>{translate( "Wählen Sie einen Kunden" )}</h3>
      <div className="pv2">
        <AccountSearch loading={loading} onChange={this.handleResult}/>
      </div>
      {/*<pre>{JSON.stringify( customers, null, 2 )}</pre>*/}
      {!loading && <div className="pa3 bg-white cf cb">
        {size > 0 && <TableAccounts onSelect={this.handleSelect} customers={searchResult} to={shop.locationAfterLogin || this.props.to || "/home"}/>}
        {/*<TableAccounts onSelect={this.handleSelect} customers={customers} to={this.props.to || "/home"}/>*/}
        {searchResult.length === 0 && <div className="pa3 tl">{translate( "keine Kunden gefunden" )}</div>}

        {useMore && <div className="pv3 tc"><Button loading={loading} onClick={this.loadMore}>{translate( "mehr" )}</Button></div>}
        <div className="fl">
          <Button as={Link} to={"/login"} basic size="small">{translate( "Logout" )}</Button>

        </div>
      </div>}
    </div>
  }
}

class AccountSearch extends Component {

  state = {
    value  : "",
    error  : false,
    loading: false
  }

  search( value, page = 1, count = 24 ) {
    this.setState( { loading: true } )
    let start = (page - 1) * count
    console.log( "SEARCH", value )
    let modifiedValue = value
    if(shop.config.USE_OLD_SEARCH){
      modifiedValue = `%${value}%`
    }
    shop.fetch( `/shop/rest/data/customers/search?title=${encodeURIComponent( `%${modifiedValue}%` )}&count=${count}&start=${start}` ) // pre-urlencoded % = %25
      .then( data => {
        console.log( { data } )
        const { size, result } = data
        this.props.onChange && this.props.onChange( { size, customers: result, query: value } )
        this.setState( { loading: false } )
      } )
      .catch( error => {
        this.setState( { error } )
        shop.toast( translate( "toast.SESSION_CLOSED" ) )
        console.error( "Error fetching customers", error )
      } )
  }

  reset = () => {
    this.props.onChange && this.props.onChange( { size: false, customers: [] } )
    this.setState( { value: "" } )
    this.search( "" )
  }

  handleChange = e => {
    let value = e.target.value
    this.setState( { value } )
    this.search( value )
    /*if ( value && value.length >= 3 ) {
      this.search( value )
    } else {
      this.props.onChange && this.props.onChange( { size: false, customers: [] } )
    }*/
  }

  render() {
    const { value, loading, error } = this.state

    return (
      <div className="AccountSearch">
        <Input className="mr2" value={value} icon="search" loading={loading} placeholder={translate("Kunde")} onChange={this.handleChange}/>
        <Button className="dib " onClick={this.reset} basic icon={"close"}/>
        {error && <Redirect to={"/login/"}/>}
      </div>
    )
  }
}


const TableAccounts = ( { to, onSelect, customers } ) => (
  <Table compact>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell></Table.HeaderCell>
        <Table.HeaderCell>ID</Table.HeaderCell>
        <Table.HeaderCell>Name</Table.HeaderCell>
        <Table.HeaderCell>{translate( "Tel" )}</Table.HeaderCell>
        <Table.HeaderCell>{translate( "Land" )}</Table.HeaderCell>
        <Table.HeaderCell>{translate( "PLZ" )}</Table.HeaderCell>
        <Table.HeaderCell>{translate( "Ort" )}</Table.HeaderCell>
        <Table.HeaderCell>E-Mail</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {customers.map( customer => {
        return (
          <Table.Row key={customer.map_id}>
            <Table.Cell>
              <Button onClick={() => {
                onSelect( { customer } )
              }} size={"tiny"} primary>{translate( "select" )}</Button>
            </Table.Cell>
            <Table.Cell>{customer.map_id}</Table.Cell>
            <Table.Cell>{customer.title}</Table.Cell>
            <Table.Cell>{customer.phone}</Table.Cell>
            <Table.Cell>{customer.country}</Table.Cell>
            <Table.Cell>{customer.pcode}</Table.Cell>
            <Table.Cell>{customer.city}</Table.Cell>
            <Table.Cell>{customer.email}</Table.Cell>
          </Table.Row>
        )
      } )}

    </Table.Body>

  </Table>
)



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/components/AdvancedLogin/AccountSelection.js